import {
  Box,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import shotShowImage from "../assets/news/shot-show.jpg";
import EGClassImage from "../assets/news/EG-class.jpg";
import worldShoot from "../assets/news/world-shoot.JPG";

const newsItems = [
  {
    key: "0", // key to match JSON
    date: { start: "2026-01-20", end: "2026-01-23" },
    image: shotShowImage,
    link: "https://shotshow.org/",
  },
  {
    key: "1",
    date: { start: "2026-01-13", end: "2026-01-16" },
    image: EGClassImage,
    link: "https://www.ericgrauffelonlineshop.com/en/",
  },
  {
    key: "2",
    date: { start: "2025-09-22", end: "2025-09-27" },
    image: worldShoot,
    link: "https://2025hws.worldshoot.org/",
  },
];

export default function News() {
  const { t } = useTranslation();
  return (
    <Box
      id="news"
      sx={{
        pt: { xs: 4, md: 6 },
        px: { xs: 2, md: 0 },
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box sx={{ width: { xs: "100%", lg: "60%" } }}>
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          sx={{ color: "text.primary" }}
        >
          {t("home.newsTitle")}
        </Typography>

        <Grid container spacing={4}>
          {newsItems.map((item) => (
            <Grid size={{ xs: 12, md: 4 }} key={item.key}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: 3,
                }}
              >
                {/* Media */}
                <CardMedia
                  component="img"
                  image={item.image}
                  alt={t(`home.news.${item.key}.title`)}
                  sx={{ width: "100%" }}
                />

                {/* Content */}
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography variant="h6" gutterBottom>
                    {t(`home.news.${item.key}.title`)}
                  </Typography>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ display: "block", mb: 1 }}
                  >
                    {item.date.end
                      ? `${new Date(item.date.start).toLocaleDateString()} – ${new Date(item.date.end).toLocaleDateString()}`
                      : new Date(item.date.start).toLocaleDateString()}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {t(`home.news.${item.key}.description`)}
                  </Typography>
                </CardContent>

                {/* Optional action */}
                {item.link && (
                  <Box sx={{ pt: 0 }}>
                    <Button
                      variant="contained"
                      size="small"
                      href={item.link}
                      color="secondary"
                      target="_blank"
                      rel="noopener"
                    >
                      {t(`home.news.${item.key}.linkText`)}
                    </Button>
                  </Box>
                )}
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}
